import { motion } from "framer-motion";
import { MaskLine, Eyebrow, Reveal, EASE } from "@/components/Reveal";

const GROUPS = [
  { title: "Strategie & Führung", skills: ["Product Strategy", "Digital Strategy", "Go-to-Market Strategy", "Marketing Strategy", "Financial Modeling", "Team Leadership", "Entrepreneurship"] },
  { title: "Produkt & Design", skills: ["Product Development", "Concept Development", "User Experience", "Lean User Experience", "Lean Product Development", "Atomic Design", "Design Studio"] },
  { title: "Agile & Projektmanagement", skills: ["Agile Methodologies", "Agile Product Development", "Project Management", "Lean Management", "Agile Coach", "Agile Enterprise", "Enterprise SCRUM", "Requirements Engineering", "Extreme Programming"] },
  { title: "Innovation & Kreativität", skills: ["Creative Entrepreneurship", "Creative Ideation", "Social Entrepreneurship", "Interdisciplinary Collaboration", "Artificial Intelligence (AI)"] },
  { title: "Operations & Growth", skills: ["Event Management", "Fundraising", "Merchandise"] },
];

export const Skills = () => (
  <section id="skills" className="py-24 md:py-36 bg-secondary" data-testid="skills-section">
    <div className="mx-auto max-w-6xl px-6 md:px-8">
      <div className="mb-16">
        <Reveal><Eyebrow className="mb-8">Expertise</Eyebrow></Reveal>
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight leading-tight">
          <MaskLine>Kompetenzen &amp; Schwerpunkte</MaskLine>
        </h2>
      </div>
      <div className="divide-y divide-border border-y border-border">
        {GROUPS.map((g, gi) => (
          <motion.div key={g.title} data-testid={`skill-group-${gi}`}
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, ease: EASE }}
            className="grid md:grid-cols-[minmax(0,1fr)_minmax(0,2.2fr)] gap-5 md:gap-10 py-8 md:py-10">
            <h3 className="flex items-baseline gap-4 text-lg font-medium tracking-tight">
              <span className="font-display text-sm text-muted-foreground">0{gi + 1}</span>{g.title}
            </h3>
            <div className="flex flex-wrap gap-2">
              {g.skills.map((s, si) => (
                <motion.span key={s}
                  initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }}
                  transition={{ duration: 0.5, ease: EASE, delay: 0.15 + si * 0.04 }}
                  className="inline-flex items-center rounded-full border border-border bg-background/60 px-4 py-2 text-sm text-foreground transition-colors duration-300 hover:bg-foreground hover:text-background hover:border-foreground cursor-default">
                  {s}
                </motion.span>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
